import React from "react";
import { useLocation } from "react-router-dom";

import { NavDivider } from "../../assets/icons";
import { CardContainer } from "./CardContainer";
import { SectionContainer } from "./SectionContainer";
import { Header } from "./Header";
import { useAppSelector } from "../../hooks/hooks";
import { NavDividerProps } from "./types";

const ViewAll: React.FC<{
  onSignInClick?: () => void;
  onSignUpClick?: () => void;
}> = ({ onSignInClick, onSignUpClick }) => {
  const location = useLocation();
  const { data: appData } = useAppSelector((state) => state.appData);

  // Extract the last path segment as the category key
  const path = location.pathname;
  const pathSegment = path.split("/").filter(Boolean).pop() || "";

  // Derive display title
  const formattedTitle =
    pathSegment?.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) ||
    "Plans";

  // Determine the data source (flatten providers if needed)
  const providers = (appData as any)[pathSegment]?.providers;
  return (
    <div>
      <div className="px-14 pt-14 pb-2">
        <div className="row-1 gap-[2px] place-items-center">
          {/* Dynamic navigation links */}
          <Navigation title="Direct Top-up Product Details" />
          <NavDivider />
          <Navigation title={formattedTitle} />
        </div>
      </div>

      <div>
        {providers && (
          <SectionContainer>
            <Header
              icon="/png/PrepaidServices.png"
              title={formattedTitle}
              viewAllUrl={pathSegment}
            />
            <CardContainer cardData={providers} url={pathSegment} />
          </SectionContainer>
        )}
      </div>
    </div>
  );
};

export default ViewAll;

const Navigation: React.FC<NavDividerProps> = ({ href, title }) => (
  <a
    href={href || "#"} // Default to "#" if href is not provided
    className="satoshi-xs-bold-toggleBG-dark dark:text-white"
  >
    {title}
  </a>
);
